import React from "react";
import Header from "src/Component/content-component/Header";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import ParaData from "src/Component/content-component/ParaData";
import MainContainer from "src/Component/grid-component/MainContainer";
import ImageContainer from "src/Component/grid-component/ImageContainer";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const img = imageBaseUrl+"International-Relation/IndiaPage/international.jpg";

const InterAtHome = () => {
  return (
    <MainContainer
      com2={
        <ContentContainer
          Header={<Header content={"INTERNATIONALISATION AT HOME"} color="#00999E" />}
          Content={
            <ParaData
              color={"#525560"}
              fontSize={"16px"}
              content={
                <>
                  Internationalisation in higher education fosters global collaboration, enhances research, and develops 
                  global citizen through student and scholar mobility. It boosts rankings, diversity, employability, and
                  institutional growth while strengthening a country's global image.
                  <br /><br /> 
                  India’s <b>National Education Policy (NEP) 2020</b> aims to transform higher education 
                  with a focus on <b>access, equity, quality, affordability, and accountability</b> 
                  The policy emphasizes <b>internationalisation at home</b>, attracting global students, 
                  and positioning India as a leading study destination offering world-class education 
                  at affordable costs—reviving its role as <b>Vishwa Guru</b>
                
             </> }
            />
          }
        />
      }
      com1={<ImageContainer img={img} />}
    />
  );
};

export default InterAtHome;
